import { NOTIFY, REMOVE_NOTIFICATION } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
    notifications : []
  }, preserve )
}

export default function (state = initialState(), action) {

  console.log('Notifications - Reducer')


  switch (action.type) {

    case NOTIFY:
      state.notifications.push( action.notification )
      state.notifications = [...state.notifications]
      break;
    case REMOVE_NOTIFICATION:
      state.notifications.forEach( ( notification, index, arrayRef ) => {
        if ( action.notification == notification ) arrayRef.splice(index, 1);
      })
      state.notifications = [...state.notifications]
      break;
    
      default:
  }

  return state
}